/* FD card helpers (Sep 18, 2026): mobile mini rating "★ (4.9)" next to the title. Badges move from the image into the info section. */
(function(){
  var STAR='<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path fill="#0e4f48" d="M12 2.6l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.5l-5.9 3.1 1.2-6.5L2.5 9.5l6.6-.9z"/></svg>';
  function mini(avg){var s=document.createElement('span');s.className='fd-mini-rating';s.innerHTML=STAR+'<span>('+avg+')</span>';return s;}
  function avgFrom(text){var m=/([0-9]+(?:\.[0-9])?)\s*out of/i.exec(text||'');return m?m[1]:null;}
  function fixCollection(card){
    if(card.dataset.fdMini) return;
    var link=card.querySelector(':scope > .product-card__content > a[ref="productTitleLink"], :scope > .product-card__content > a.contents');
    var rating=card.querySelector('.rating-wrapper .rating[aria-label]');
    if(!link||!rating) return;
    card.dataset.fdMini='1';
    var avg=avgFrom(rating.getAttribute('aria-label')); if(!avg) return;
    var row=document.createElement('div');row.className='fd-title-row';
    link.parentNode.insertBefore(row,link);row.appendChild(link);row.appendChild(mini(avg));
  }
  function fixHome(card){
    if(card.dataset.fdMini) return;
    var row=card.querySelector('.fd-title-row--home');var hidden=card.querySelector('.td-hsupp__rating .visually-hidden, .td-happ__rating .visually-hidden');
    if(!row||!hidden) return;
    card.dataset.fdMini='1';
    var avg=avgFrom(hidden.textContent); if(!avg) return;
    row.appendChild(mini(avg));
  }
  /* Badges off the image (Oct 2026): move the card's badges out of the gallery into the
     info section, into the rating row when the card has one, else above the title. A
     re-render that puts badges back in the gallery replaces the moved copy. */
  function moveBadges(card){
    var gallery=card.querySelector('.card-gallery'); if(!gallery) return;
    var badges=gallery.querySelector('.product-badges'); if(!badges) return;
    var moved=card.querySelector('.fd-card-badges'); if(moved) moved.remove();
    if(!badges.querySelector('.product-badges__badge')){ badges.remove(); return; }
    badges.classList.add('fd-card-badges');
    var content=gallery.parentNode;
    var rating=content.querySelector(':scope > .rating-wrapper');
    if(rating){ rating.appendChild(badges); return; }
    var title=content.querySelector(':scope > .fd-title-row, :scope > a.contents, :scope > a[ref="productTitleLink"]');
    if(title){ badges.classList.add('fd-card-badges--eyebrow'); content.insertBefore(badges,title); }
  }
  /* Homepage carousel cards: same spot, the rating row, so the title keeps its full width */
  function moveHomeBadge(card){
    var badge=card.querySelector('.fd-title-row--home .fd-home-badge');
    var rating=card.querySelector('.td-hsupp__rating, .td-happ__rating');
    if(badge&&rating) rating.appendChild(badge);
  }
  /* Card dots (Oct 20 2026): at most 5 at a time around the current photo, smaller at an edge
     that has more beyond it; slides hidden by a variant filter get no dot. */
  function windowDots(el){
    var sc=el.closest('slideshow-component'); if(!sc) return;
    /* Runs straight from the MutationObserver, which fires before the next paint, so the window
       moves in the same frame as the selection (a requestAnimationFrame here painted one frame with
       the pill off centre). If no dot reads as selected, keep the last known position. */
    var last=0;
    var apply=function(){
      var slides=sc.querySelectorAll('slideshow-slide'), items=el.querySelectorAll('li'), vis=[], sel=-1;
      items.forEach(function(li,i){ var b=li.querySelector('button'); if(b&&b.getAttribute('aria-selected')==='true') sel=i; if(slides[i]&&!slides[i].hasAttribute('hidden')) vis.push(i); });
      if(sel<0) sel=last; last=sel;
      var pos=Math.max(0,vis.indexOf(sel)), start=Math.min(Math.max(0,pos-2),Math.max(0,vis.length-5)), end=start+5;
      el.classList.toggle('fd-dots--none',vis.length<2);
      items.forEach(function(li,i){
        var v=vis.indexOf(i), show=v>=start&&v<end;
        li.classList.toggle('fd-dot--off',!show);
        li.classList.toggle('fd-dot--small',show&&((v===start&&start>0)||(v===end-1&&end<vis.length)));
      });
    };
    apply();
    new MutationObserver(apply).observe(el,{subtree:true,attributes:true,attributeFilter:['aria-selected']});
    var scroller=sc.querySelector('slideshow-slides');
    if(scroller) new MutationObserver(apply).observe(scroller,{subtree:true,attributes:true,attributeFilter:['hidden']});
  }
  function run(root){
    (root||document).querySelectorAll('.td-hsupp__card, .td-happ__card').forEach(moveHomeBadge);
    (root||document).querySelectorAll('product-card.product-card').forEach(moveBadges);
    (root||document).querySelectorAll('product-card.product-card').forEach(fixCollection);
    (root||document).querySelectorAll('.td-hsupp__card, .td-happ__card').forEach(fixHome);
    (root||document).querySelectorAll('.card-gallery__dots:not([data-fd-dots])').forEach(function(el){ el.setAttribute('data-fd-dots',''); windowDots(el); });
  }
  function arm(){ run(); new MutationObserver(function(m){ run(); }).observe(document.body,{childList:true,subtree:true}); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',arm); else arm();
})();
